import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil, Subject, forkJoin } from 'rxjs';
import { OrganisationType } from '../../../core/models/organisation.model';
import { BpService } from '../../../core/services/bp.service';
import { EditEntrepreneurFields, EditOrganisationFields } from '../organisation.model';
import { OrganizationApiService } from '../../../core/modules/organization/organization-api.service';

@Component({
  selector: 'tax-organization-edit',
  templateUrl: 'organization-edit.component.html',
})

export class OrganizationEditComponent implements OnInit, OnDestroy {
  readonly OrganisationType = OrganisationType;

  organization?: EditEntrepreneurFields | EditOrganisationFields;
  organizationType?: OrganisationType;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private organizationApiService: OrganizationApiService,
    private bpService: BpService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.getOrganisation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  goToOrganisationPage(): void {
    this.router.navigate(['/main/organization']);
  }

  submitForm(organization: EditEntrepreneurFields | EditOrganisationFields): void {
    this.bpService.submitCurrentBp(organization)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.goToOrganisationPage();
      });
  }

  private getOrganisation(): void {
    forkJoin([
      this.organizationApiService.fetchOrganization(),
      this.bpService.startBpAndGetData('updateOrg', {}),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([organization, response]) => {
        this.organization = response.fields;
        this.organizationType = organization.type.toString() as OrganisationType;
      });
  }
}
